import { DEFAULT_TAG_FILTERS_STATE } from './consts';
import { TagFiltersAction, TagFiltersState } from './types';

export const tagFiltersReducer = (state: TagFiltersState, action: TagFiltersAction): TagFiltersState => {
  switch (action.type) {
    case 'setSearchQuery': {
      return {
        ...state,
        searchQuery: action.searchQuery,
      };
    }
    case 'setSelectedTags': {
      return {
        ...state,
        selectedTags: action.selectedTags,
      };
    }
    case 'setIsExpanded': {
      return {
        ...state,
        isExpanded: action.isExpanded,
      };
    }
    case 'setShownTags': {
      return {
        ...state,
        shownTags: action.shownTags,
      };
    }
    case 'setShowAllTags': {
      return {
        ...state,
        showAllTags: action.showAllTags,
      };
    }
    case 'setMoreTagsCount': {
      return {
        ...state,
        moreTagsCount: action.moreTagsCount,
      };
    }
    case 'resetState': {
      return {
        ...state,
        ...DEFAULT_TAG_FILTERS_STATE,
      };
    }
    default:
      return state;
  }
};
